import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAuth } from 'providers/auth-provider'
import SalesIgStoryPage from './pages/sales-ig-story-page'
import SalesIgStorySaAssignmentDetailPage from './pages/sales-ig-story-sa-assignment-detail-page'
import { canUseMyQueue, canUseAuditQueue } from './access'

const canOpenAuditQueue = (user) => (
  canUseAuditQueue(user) ||
  (
    String(user?.role || '').trim().toLowerCase() === 'sales' &&
    String(user?.email || '').trim().toLowerCase() === 'angel@belleandkate.com'
  )
)

export const MyQueuePage = (props) => {
  const { user } = useAuth()
  return canUseMyQueue(user) ? <SalesIgStoryPage {...props} /> : <Redirect to='/app' />
}
export const AuditQueuePage = (props) => {
  const { user } = useAuth()
  return canOpenAuditQueue(user) ? <SalesIgStoryPage {...props} auditMode /> : <Redirect to='/app' />
}

export const SaAssignmentDetailPage = (props) => {
  const { user } = useAuth()
  return canOpenAuditQueue(user) ? <SalesIgStorySaAssignmentDetailPage {...props} /> : <Redirect to='/app' />
}
export const IgStoryLanding = () => {
  const { user } = useAuth()
  if (canOpenAuditQueue(user)) return <Redirect to='/app/sales/ig-story/audit-queue' />
  if (canUseMyQueue(user)) return <Redirect to='/app/sales/ig-story/my-queue' />
  return <Redirect to='/app' />
}
